import { useParams, Link } from "react-router-dom";
import { articles, type Article } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/feature/ArticleCard";
import Breadcrumb from "@/components/feature/Breadcrumb";
import CategoryTabs from "@/components/feature/CategoryTabs";
import SchemaOrg from "@/components/feature/SchemaOrg";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  const filteredArticles: Article[] = category
    ? articles.filter((a) => a.category === slug)
    : articles;

  return (
    <>
      {category && (
        <SchemaOrg
          type="WebPage"
          data={{
            name: `51吃瓜 - ${category.name}`,
            description: category.description,
            url: `https://51chigua.com/category/${slug}`,
            isPartOf: {
              "@type": "WebSite",
              name: "51吃瓜",
              url: "https://51chigua.com",
            },
          }}
        />
      )}

      <main className="min-h-screen pt-16">
        <div className="bg-background-50 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-10">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category ? category.name : "全部内容" },
              ]}
            />

            {category ? (
              <div className="mt-4">
                <div className="flex items-center gap-3 mb-2">
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br ${category.color}`}
                  >
                    <i className={`${category.icon} text-white text-lg`}></i>
                  </div>
                  <h1 className="text-2xl md:text-3xl font-bold text-foreground-900">
                    {category.name}
                  </h1>
                </div>
                <p className="text-foreground-600 text-sm md:text-base ml-13">
                  {category.description}
                </p>
              </div>
            ) : (
              <div className="mt-4">
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-900">
                  全部内容
                </h1>
                <p className="text-foreground-600 text-sm md:text-base mt-1">
                  浏览51吃瓜所有栏目内容
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8">
          <CategoryTabs />

          {filteredArticles.length > 0 ? (
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {filteredArticles.map((article) => (
                <ArticleCard key={article.slug} {...article} />
              ))}
            </div>
          ) : (
            <div className="mt-10 text-center py-16">
              <i className="ri-inbox-line text-4xl text-foreground-400"></i>
              <p className="text-foreground-500 mt-3">该栏目暂无内容，敬请期待</p>
              <Link
                to="/"
                className="mt-4 inline-block px-5 py-2 bg-rose-500 text-white rounded-full text-sm font-medium hover:bg-rose-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                返回首页
              </Link>
            </div>
          )}

          {filteredArticles.length > 0 && (
            <div className="mt-8 text-center">
              <p className="text-foreground-500 text-sm">
                共 {filteredArticles.length} 篇内容
              </p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}